import React from "react"
import CMSRender from "aldoo-ra/CMS/cms-render"
import Typography from "aldoo-ra/Typography"

const PWUCollaborate = () => {
  return (
    <CMSRender
      contentType="PWUCollaborate"
      match={{ "content.title": "We collaborate with leading organizations" }}
      renderItem={(data, id) => {
        return (
          <div className="w-full px-[16px] md:px-px1_l xl:px-px1_xl">
            {/* Colored Container */}
            <div
              key={id}
              className="w-full lg:max-w-w1_xl bg-gradient_pwu_collaborate rounded-[70px] px-[32px] lg:px-[60px] xl:px-[120px] pt-[58px] pb-[76px] mx-auto"
            >
              <div className="mx-auto">
                {/* Title - Centered */}
                <Typography
                  variant="h2"
                  className="text-text text-center mb-[76px] lg:mb-[65px]"
                >
                  {data.title}
                </Typography>

                {/* Logo Row - Evenly spaced */}
                <div className="w-full max-w-[264px] md:max-w-[600px] lg:max-w-[1100px] flex flex-wrap items-center justify-center lg:justify-between gap-x-[70px] lg:gap-x-0 gap-y-[40px] lg:gap-y-0 mx-auto">
                  {data.logos?.map((logo, index) => (
                    <img
                      key={index}
                      src={logo}
                      alt={`Partner logo ${index + 1}`}
                      className="w-auto object-contain"
                    />
                  ))}
                </div>
              </div>
            </div>
          </div>
        )
      }}
    />
  )
}

export default PWUCollaborate
